import { Component, OnInit } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { DialogInputComponent } from '../dialog-input/dialog-input.component';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss'],
    standalone: false
})
export class UserDetailComponent implements OnInit {

  contents =  []
  dataSource: any = null

  email = ""
  userId = ""

  columnNames = [
    {
      id:'codes',
      value: 'Code'
    },
    {
      id:'description',
      value:'Description'
    },
    {
      id:'content',
      value:'Content'
    },
    {
      id:'step',
      value:'Step'
    },
    {
      id:'total_steps',
      value:'Total steps'
    },
    {
      id:'time_spent',
      value:'Time spent'
    },
    {
      id:'status',
      value:"Status"
    },
    {
      id:'actions',
      value:'Actions'
    }
  ]

  displayedColumns = this.columnNames.map(x => x.id)

  constructor(private router: Router,private httpService: HttpService, private route: ActivatedRoute, private modalService: NgbModal) { }

  ngOnInit() {

    this.dataSource = new MatTableDataSource(this.contents);

    this.route.url.subscribe( async (url) =>{

      this.userId = url[1].path

      await this.fetchUser()
    })
  }


  async fetchUser(){
    const contentsResponse:any = await this.httpService.postAsync('user/getContentForUser', {userId:this.userId})

    if( contentsResponse.success ){
      this.contents = contentsResponse.data
      this.email = contentsResponse.email

      this.dataSource.data = this.contents.map( (it) => {
        return {
        ...it,
        complete: it.step > 0 && it.step == it.total_steps ? true : it.total_steps > 0 ? false : null,
        notStarted: it.step == null ? true : false
        }
      })
    }
  }

  async openBootstrapModal(text) {
    try{
      const modalRef = this.modalService.open(DialogConfirmComponent, {
        windowClass: 'center-modal-window'
      });
      modalRef.componentInstance.message = text;
      const result = await modalRef.result
      return result
    }
    catch( e ){
      return false
    }
  }

  async openBootstrapInputModal(text, placeholder, value) {
    try{
      const modalRef = this.modalService.open(DialogInputComponent, {
        windowClass: 'center-modal-window'
      });
      modalRef.componentInstance.message = text;
      modalRef.componentInstance.placeholder = placeholder;
      modalRef.componentInstance.value = value;
      const result = await modalRef.result
      return result
    }
    catch( e ){
      return false
    }
  }

  async reset(hcontentId){

    if( !await this.openBootstrapModal("Are you sure you want to reset this content?") ){
      return
    }

    const resp:any = await this.httpService.postAsync("user/resetProgress", {hcontentId, userId: this.userId})
    if( resp.success ){
      await this.fetchUser()
    }else{
      alert( resp.message )
    }
  }
  async complete(hcontentId){

    if( !await this.openBootstrapModal("Are you sure you want to mark this content as complete?") ){
        return
    }

    const resp:any = await this.httpService.postAsync("user/markComplete", {hcontentId, userId: this.userId})
    if( resp.success ){
      await this.fetchUser()
    }else{
      alert( resp.message )
    }
  }

  async deleteUser(){
    const confirmEmail = await this.openBootstrapInputModal('<span style="font-weight:bold;color:red;font-size:2rem;">Deleting a user is irreversible!</span>', "Confirm user email", "")

    if( !confirmEmail ){
        return
    }

    if( confirmEmail.trim().toLowerCase() == this.email ){
      await this.httpService.postAsync("hclient/deleteUser", {userId:this.userId, email: this.email})
      this.router.navigate(['client/_ALL_/user'])
    }else{
      alert("Email does not match.")
    }
  }

  async updateEmail(){
    const email = await this.openBootstrapInputModal("Enter new user email", "user email", this.email)
    
    // basic regex validation that email is an email address
    if( email && !email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) ){
      alert("Invalid email address")
      return
    }
    if( email ){
      const resp:any = await this.httpService.postAsync("hclient/updateEmail", {userId:this.userId, oldEmail: this.email, email: email.trim().toLowerCase()})
      if( resp.success ){
        this.fetchUser()
      }else{
        alert(resp.message)
      }
    }
  }

}
